module.exports = __webpack_public_path__ + "img/wallet.f00935d7.png";